module.exports = __webpack_public_path__ + "static/media/0023_IMG_LES_ENSEIGNES_LE_CHARCUTIER_SCRABBLE.1b73f35d.webp";